import { Link } from "react-router-dom";
import { Instagram, Twitter, Facebook } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-forest text-sand/90 mt-24" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <div className="font-serif text-2xl">handmade<span className="italic text-terra">giftkart</span></div>
          <p className="text-sm text-sand/70 mt-4 leading-relaxed max-w-xs">
            A marketplace for India's independent makers. Handmade with heart, delivered with care.
          </p>
          <div className="flex gap-3 mt-6">
            {[Instagram, Twitter, Facebook].map((Ic, i) => (
              <a key={i} href="#" className="w-9 h-9 grid place-items-center rounded-full border border-sand/30 hover:bg-clay hover:border-clay transition-colors" aria-label="social">
                <Ic className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>
        <div>
          <div className="overline text-terra mb-4">Shop</div>
          <ul className="space-y-2 text-sm text-sand/75">
            <li><Link to="/shop" className="hover:text-sand">All Gifts</Link></li>
            <li><Link to="/shop?recipient=For Her" className="hover:text-sand">For Her</Link></li>
            <li><Link to="/shop?recipient=For Him" className="hover:text-sand">For Him</Link></li>
            <li><Link to="/shop?festival=Diwali" className="hover:text-sand">Festive Edit</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline text-terra mb-4">Makers</div>
          <ul className="space-y-2 text-sm text-sand/75">
            <li><Link to="/sell" className="hover:text-sand">Start Selling</Link></li>
            <li><Link to="/sell" className="hover:text-sand">Seller Dashboard</Link></li>
            <li><span>0% listing fees</span></li>
            <li><span>Commission only 5–10%</span></li>
          </ul>
        </div>
        <div>
          <div className="overline text-terra mb-4">Help</div>
          <ul className="space-y-2 text-sm text-sand/75">
            <li><span>Prepaid orders only</span></li>
            <li><span>Delivery per product</span></li>
            <li><span>Verified reviews</span></li>
            <li><span>hello@handmadegiftkart.com</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-sand/15">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-sand/50">
          <span>© {new Date().getFullYear()} handmadegiftkart.com — Made in India</span>
          <span>Crafted with love · Handpicked for you</span>
        </div>
      </div>
    </footer>
  );
}
